<template>
  <div class="ranking-page">
    <section class="category-section">
      <div class="section-layout">
        <div class="section-title">
          <h2>热门排行</h2>
        </div>
        <div class="section-content">
          <div class="works-list">
            <div class="work-card" v-for="item in works.hot" :key="item.id" @click="goDetail(item.id)">
              <img :src="item.cover" class="work-cover" />
              <div class="work-info">
                <h3>{{ item.title }}</h3>
                <p>作者：{{ item.author }}</p>
                <p class="desc">{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="category-section">
      <div class="section-layout">
        <div class="section-title">
          <h2>新作排行</h2>
        </div>
        <div class="section-content">
          <div class="works-list">
            <div class="work-card" v-for="item in works.new" :key="item.id" @click="goDetail(item.id)">
              <img :src="item.cover" class="work-cover" />
              <div class="work-info">
                <h3>{{ item.title }}</h3>
                <p>作者：{{ item.author }}</p>
                <p class="desc">{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="category-section">
      <div class="section-layout">
        <div class="section-title">
          <h2>完结排行</h2>
        </div>
        <div class="section-content">
          <div class="works-list">
            <div class="work-card" v-for="item in works.completed" :key="item.id" @click="goDetail(item.id)">
              <img :src="item.cover" class="work-cover" />
              <div class="work-info">
                <h3>{{ item.title }}</h3>
                <p>作者：{{ item.author }}</p>
                <p class="desc">{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="category-section">
      <div class="section-layout">
        <div class="section-title">
          <h2>收藏排行</h2>
        </div>
        <div class="section-content">
          <div class="works-list">
            <div class="work-card" v-for="item in works.favorite" :key="item.id" @click="goDetail(item.id)">
              <img :src="item.cover" class="work-cover" />
              <div class="work-info">
                <h3>{{ item.title }}</h3>
                <p>作者：{{ item.author }}</p>
                <p class="desc">{{ item.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getRankingComics, BASE_URL } from '../api/index';
import youthModeManager from '@/utils/youthMode';

export default {
  name: 'RankingPage',
  data() {
    return {
      works: {
        hot: [],
        new: [],
        completed: [],
        favorite: []
      }
    }
  },
  created() {
    this.fetchHotRanking();
    this.fetchNewRanking();
    this.fetchCompletedRanking();
    this.fetchFavoriteRanking();
  },
  methods: {
    async fetchHotRanking() {
      try {
        await youthModeManager.ensureReady();
        const res = await getRankingComics({ page: 1, limit: 16 });
        if (res.data && res.data.code === 1) {
          this.works.hot = youthModeManager.filterForYouth(res.data.data.list).map(item => ({
            id: item.id,
            cover: item.cover.startsWith('http') ? item.cover : BASE_URL + item.cover,
            title: item.title,
            author: item.author,
            desc: item.description
          }));
        }
      } catch (e) { /* ignore */ }
    },
    async fetchNewRanking() {
      try {
        await youthModeManager.ensureReady();
        const res = await getRankingComics({ page: 1, limit: 16 });
        if (res.data && res.data.code === 1) {
          let arr = youthModeManager.filterForYouth(res.data.data.list).map(item => ({
            id: item.id,
            cover: item.cover.startsWith('http') ? item.cover : BASE_URL + item.cover,
            title: item.title,
            author: item.author,
            desc: item.description
          }));
          // 新作排行：使用热门数据但切换顺序（后半部分在前，前半部分在后）
          this.works.new = [...arr.slice(8), ...arr.slice(0, 8)];
        }
      } catch (e) { /* ignore */ }
    },
    async fetchCompletedRanking() {
      try {
        await youthModeManager.ensureReady();
        const res = await getRankingComics({ page: 1, limit: 16 });
        if (res.data && res.data.code === 1) {
          let arr = youthModeManager.filterForYouth(res.data.data.list).map(item => ({
            id: item.id,
            cover: item.cover.startsWith('http') ? item.cover : BASE_URL + item.cover,
            title: item.title,
            author: item.author,
            desc: item.description
          }));
          // 完结排行：使用热门数据但反向排列
          this.works.completed = [...arr].reverse();
        }
      } catch (e) { /* ignore */ }
    },
    async fetchFavoriteRanking() {
      try {
        await youthModeManager.ensureReady();
        const res = await getRankingComics({ page: 1, limit: 16 });
        if (res.data && res.data.code === 1) {
          let arr = youthModeManager.filterForYouth(res.data.data.list).map(item => ({
            id: item.id,
            cover: item.cover.startsWith('http') ? item.cover : BASE_URL + item.cover,
            title: item.title,
            author: item.author,
            desc: item.description
          }));
          // 收藏排行：使用热门数据但交错排列（奇偶分开后合并）
          const oddItems = arr.filter((_, index) => index % 2 === 0);
          const evenItems = arr.filter((_, index) => index % 2 === 1);
          this.works.favorite = [...oddItems, ...evenItems];
        }
      } catch (e) { /* ignore */ }
    },
    goDetail(id) {
      this.$router.push({ name: 'ComicDetail', params: { id } });
    }
  }
}
</script>

<style scoped>
.ranking-page {
  width: 100%;
  min-height: 100%;
  background: var(--bg);
  position: relative;
}

.category-section {
  background: var(--surface);
  border: 1px solid var(--border);
  margin: 20px 0;
  border-radius: 12px;
  min-height: 120px;
  padding: 30px;
}

.section-layout {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.section-title {
  flex-shrink: 0;
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
}

.section-content {
  flex: 1;
  min-width: 0;
}

.category-section h2 {
  font-size: 24px;
  font-weight: bold;
  margin: 0;
  color: var(--text);
  line-height: 1.2;
}

.category-section h2::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 20px;
  background: var(--brand);
  border-radius: 2px;
  margin-right: 10px;
  vertical-align: middle;
}

.works-list {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: auto;
  gap: 15px;
  width: 100%;
}
.work-card {
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform var(--t-fast), border-color var(--t-fast);
  cursor: pointer;
  min-width: 0;
  width: 100%;
}

.work-card:hover {
  transform: translateY(-5px);
  border-color: var(--brand-soft);
}
.work-cover {
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 6px;
  margin-bottom: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.work-info {
  text-align: center;
  width: 100%;
}
.work-info h3 {
  font-size: 13px;
  margin: 0 0 3px 0;
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.work-info p {
  font-size: 11px;
  margin: 0 0 2px 0;
  color: var(--text-dim);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.work-info .desc {
  color: #cccccc;
  font-size: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

/* 响应式设计 */
@media (max-width: 1600px) {
  .works-list {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (max-width: 1200px) {
  .works-list {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (max-width: 768px) {
  .section-layout {
    flex-direction: column;
    gap: 20px;
  }

  .section-title {
    width: 100%;
    justify-content: flex-start;
    min-height: auto;
  }

  .category-section h2 {
    writing-mode: horizontal-tb;
    text-orientation: mixed;
    letter-spacing: 4px;
    font-size: 20px;
  }

  .works-list {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
  .work-cover {
    height: 120px;
  }
  .work-info h3 {
    font-size: 12px;
    color: #ffffff;
  }
  .work-info p {
    font-size: 10px;
    color: #e0e0e0;
  }
  .work-info .desc {
    font-size: 9px;
    color: #cccccc;
  }
}
@media (max-width: 480px) {
  .category-section {
    padding: 20px;
  }

  .section-layout {
    gap: 15px;
  }

  .category-section h2 {
    font-size: 18px;
    letter-spacing: 2px;
  }

  .works-list {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  .work-cover {
    height: 100px;
  }
  .work-info h3 {
    font-size: 11px;
    color: #ffffff;
  }
  .work-info p {
    font-size: 9px;
    color: #e0e0e0;
  }
  .work-info .desc {
    font-size: 8px;
    color: #cccccc;
  }
}
</style> 